import React, { useContext, useMemo } from 'react';

/**
 * @typedef {import('./drawer-types.d.ts').DrawerContextType} DrawerContextType
 * @typedef {import('./drawer-types.d.ts').DrawerContextValue} DrawerContextValue
 * @typedef {import('./drawer-types.d.ts').DrawerProviderType} DrawerProviderType
 */

/**
 * @type {DrawerContextType}
 */
export const Context = React.createContext({});

const { Consumer, Provider } = Context;

/**
 * @returns {DrawerContextValue}
 */
const useDrawerContext = () => useContext(Context);

/**
 * @type {DrawerProviderType}
 */
const DrawerProvider = ({ children, onCancel, onClose }) => {
  const value = useMemo(
    () => ({
      onCancel,
      onClose,
    }),
    [onCancel, onClose],
  );

  return <Provider value={value}>{children}</Provider>;
};

export { Consumer, DrawerProvider, useDrawerContext };
